<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="foreword" id="_idContainer004" role="doc-foreword">
<p class="fl-fl-roman"><b>Winnie Griggs </b>is the multipublished, award-winning author of historical (and occasionally contemporary) romances that focus on small towns, big hearts and amazing grace. She is also a list maker and a lover of dragonflies, and holds an advanced degree in the art of procrastination. Winnie loves to hear from readers—you can connect with her on Facebook at <a href="https://www.facebook.com/WinnieGriggs.Author/" target="_blank">Facebook.com/winniegriggs.author</a> or email her at <a href="mailto:winnie%40winniegriggs.com?subject=Contact%20Winnie%20Griggs">winnie@winniegriggs.com</a>.</p>
<p class="pl-center-bold"><b>Books by Winnie Griggs</b></p>
<p class="pl-booklist-series">Love Inspired Historical</p>
<p class="pl-booklist-miniseries"><span class="bold-italic">Texas Grooms</span></p>
<p class="pl-booklist-titles">Handpicked Husband</p>
<p class="pl-booklist-titles">The Bride Next Door</p>
<p class="pl-booklist-titles">A Family for Christmas</p>
<p class="pl-booklist-titles">Lone Star Heiress</p>
<p class="pl-booklist-titles">Her Holiday Family</p>
<p class="pl-booklist-titles">Second Chance Hero</p>
<p class="pl-booklist-titles">The Holiday Courtship</p>
<p class="pl-booklist-titles">Texas Cinderella</p>
<p class="pl-booklist-titles">A Tailor-Made Husband</p>
<p class="pl-booklist-titles">Once Upon a Texas Christmas</p>
<p class="pl-center"><span class="roman">Visit the Author Profile page<br/>at </span><a href="http://www.LoveInspired.com" target="_blank">LoveInspired.com</a><span class="hyperlink"> for more titles</span><span class="roman">.</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// About_the_Author.vue?63849d14